import storage from '../lib/storage';

// path에 org 파라미터를 추가하는 헬퍼 함수
export const addOrgToPath = (path) => {
  const org = storage.get('org');
  // org가 없거나 'acon'이면 URL에 추가하지 않음 (기본값이므로)
  if (!org || org === 'acon') return path;

  // path에 이미 query string이 있는지 확인
  const [basePath, queryString] = path.split('?');
  const queryParams = new URLSearchParams(queryString || '');

  // org가 이미 있으면 유지, 없으면 추가
  if (!queryParams.has('org')) {
    queryParams.set('org', org);
  }

  const newQueryString = queryParams.toString();
  return newQueryString ? `${basePath}?${newQueryString}` : basePath;
};

// 현재 URL의 org 파라미터를 가져와서 path에 추가하는 헬퍼 함수
export const addOrgFromCurrentUrl = (path, currentLocation) => {
  // currentLocation이 없으면 window.location 사용
  const search = currentLocation?.search || window.location.search;
  const queryParams = new URLSearchParams(search);
  // 우선순위: URL 파라미터 > localStorage > 기본값 'acon'
  const urlOrg = queryParams.get('org');
  const storedOrg = storage.get('org');
  const org = urlOrg || storedOrg || 'acon';

  // org가 'acon'이면 URL에 추가하지 않음 (기본값이므로)
  if (org === 'acon') return path;

  // path가 location 객체인지 확인
  if (typeof path === 'object' && path !== null) {
    // location 객체인 경우
    const location = { ...path };
    const existingSearch = location.search || '';
    const newQueryParams = new URLSearchParams(existingSearch);

    // org가 이미 있으면 유지, 없으면 추가
    if (!newQueryParams.has('org')) {
      newQueryParams.set('org', org);
    }

    const newQueryString = newQueryParams.toString();
    location.search = newQueryString ? `?${newQueryString}` : '';
    return location;
  }

  // path가 문자열인 경우
  if (typeof path === 'string') {
    // path에 이미 query string이 있는지 확인
    const [basePath, queryString] = path.split('?');
    const newQueryParams = new URLSearchParams(queryString || '');

    // org가 이미 있으면 유지, 없으면 추가
    if (!newQueryParams.has('org')) {
      newQueryParams.set('org', org);
    }

    const newQueryString = newQueryParams.toString();
    return newQueryString ? `${basePath}?${newQueryString}` : basePath;
  }

  // 예상치 못한 타입인 경우 원본 반환
  return path;
};




